import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Modal, Button, Row, Col, Form, Spin } from 'antd';
import { connect } from 'dva';
import { CancelToken } from 'axios';
import Text from 'antd/es/typography/Text';
import RemoteSelectInput from '../../../common/DataEntry/RemoteSelectInput';
import { findCompanyByName } from '../../../../services/hubspot';

function SearchCreateCompanyModal(props) {
  const [visible, setVisible] = useState(props.visible);
  const [companyName, setCompanyName] = useState(props.companyName);
  const [companyId, setCompanyId] = useState(props.companyId);
  const [hubspotCompanyId, setHubspotCompanyId] = useState(props.companyId);

  useEffect(() => {
    setVisible(props.visible);
    setCompanyName(props.companyName);
    setCompanyId(props.companyId);
  }, [props]);


  const createCompany = async () => {
    await props.onCompanySelected(null, companyId);
    setVisible(false);
    setHubspotCompanyId(null);
  };

  const useExistingCompany = async () => {
    await props.onCompanySelected(hubspotCompanyId, companyId);
    setVisible(false);
    setHubspotCompanyId(null);
  };

  const loadCompanies = (query) => {
    let cancel;
    const requestConfig = {
      cancelToken: new CancelToken((c) => {
        cancel = c;
      }),
    };

    const request = findCompanyByName(
      { projectId: props.app.currentProject.id },
      { companyName: query || companyName },
      requestConfig,
    );

    return {
      request,
      cancel,
    };
  };

  const onChange = (value) => {
    setHubspotCompanyId(value);
  };

  const hide = async () => {
    await props.onCancel();
    setVisible(false);
    setHubspotCompanyId(null);
  };

  return (
    <Modal
      title={props.title}
      visible={visible}
      onCancel={hide}
      footer={null}
      destroyOnClose
    >
      <Spin spinning={!!props.loading.effects['hubspot/createHubspotCompany'] || props.isLoading}>
        <Row gutter={6}>
          {/* eslint-disable-next-line react/no-danger */}
          <p dangerouslySetInnerHTML={{ __html: props.intl.formatMessage({ id: props.description1 }) }} />
        </Row>
        <Row gutter={6}>
          <p>
            <Text strong>
              <FormattedMessage id="Component.SearchCreateCompanyModal.Text.CompanyNameInLxp" />
            </Text>
            <br />
            {companyName}
          </p>
        </Row>

        <Row gutter={6}>
          <Col>
            <Form.Item
              colon={false}
              label={props.intl.formatMessage({ id: 'Component.SearchCreateCompanyModal.Text.CompanyNameFormLabel' })}
            >
              <RemoteSelectInput
                style={{ width: '100%' }}
                idKey="hs_object_id"
                nameKey="name"
                remoteLoader={loadCompanies}
                showArrow
                notFoundContent={props.intl.formatMessage({ id: 'Component.SearchCreateCompanyModal.Text.NoCompaniesFound' })}
                defaultQuery={companyName}
                placeholder={props.intl.formatMessage({ id: 'Component.SearchCreateCompanyModal.Text.CompanyNamePlaceholder' })}
                onChange={onChange}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row type="flex" gutter={6}>
          <Col span={12}>
            <Button type="default" onClick={createCompany} style={{ width: '100%' }}>
              <FormattedMessage id="Component.SearchCreateCompanyModal.Button.CreateNewCompany" />
            </Button>
          </Col>
          <Col span={12}>
            <Button type="primary" onClick={useExistingCompany} disabled={!hubspotCompanyId} style={{ width: '100%' }}>
              <FormattedMessage id="Component.SearchCreateCompanyModal.Button.UseExistingCompany" />
            </Button>
          </Col>
        </Row>
      </Spin>
    </Modal>
  );
}

SearchCreateCompanyModal.propTypes = {
  visible: PropTypes.bool,
  companyId: PropTypes.number,
  companyName: PropTypes.string,
  onCompanySelected: PropTypes.func,
  onCancel: PropTypes.func,
  title: PropTypes.string,
  description1: PropTypes.string,
  isLoading: PropTypes.bool,
};

SearchCreateCompanyModal.defaultProps = {
  title: 'Hubspot Company',
  description1: 'Component.SearchCreateCompanyModal.Description1',
  isLoading: false,
};

export default connect((
  {
    app, loading, hubspot,
  },
) => (
  {
    app, loading, hubspot,
  }
))(injectIntl(SearchCreateCompanyModal));



// WEBPACK FOOTER //
// ./src/components/Leads/Hubspot/SearchCreateCompanyModal/index.js